// extracted by css-extract-rspack-plugin
export default {"placeholderClass":"_8140ccd3"};